module.exports = __webpack_public_path__ + "img/L_ok.3f89553a.png";